import React from 'react';
import Heading from '@amzn/meridian/heading';
import Text from '@amzn/meridian/text';
import Row from '@amzn/meridian/row';
import Tooltip from '@amzn/meridian/tooltip';
import Box from '@amzn/meridian/box';
import infoKnockoutTokens from '@amzn/meridian-tokens/base/icon/info-knockout';
import Icon from '@amzn/meridian/icon';
import { chainWalk } from '../../utils/helpers';
import { Column } from '@amzn/meridian';

const HeadcountView = ({ adherenceData }) => {
  const headcountData = chainWalk(
    () =>
      adherenceData['timeWindowAdherences']
        .filter((adherence) => adherence['activeShifts'].includes('ALL_CYCLES') && adherence['type'] === 'headcount')
        .sort(
          (firstAdherence, secondAdherence) =>
            secondAdherence.timeWindow.startInSeconds - firstAdherence.timeWindow.startInSeconds
        )[0],
    {}
  );

  const dataTime = chainWalk(
    () => new Date(headcountData.timeWindow.endInSeconds * 1000).toISOString().substring(0, 16).replace('T', ' '),
    '-'
  );

  const expectedData = chainWalk(
    () =>
      headcountData.processAdherences.filter((data) => data.entityAttrs.process === 'Rostered')[0].planned.toFixed(0),
    '-'
  );
  const onsiteData = chainWalk(() => headcountData.overallAdherence.actual.toFixed(0), '-');
  const inductData = chainWalk(
    () =>
      headcountData.processAdherences.filter((data) => data.entityAttrs.process === 'Inducted')[0].actual.toFixed(0),
    '-'
  );
  const stowData = chainWalk(
    () => headcountData.processAdherences.filter((data) => data.entityAttrs.process === 'Stowed')[0].actual.toFixed(0),
    '-'
  );
  const pickStageData = chainWalk(
    () =>
      headcountData.processAdherences.filter((data) => data.entityAttrs.process === 'Outbound')[0].actual.toFixed(0),
    '-'
  );

  return (
    <Box type="outline" spacingInset="400">
      <Heading level={2} type="h300" alignment="left" className="overview-fph">
        Headcount
        <Tooltip position="end" title={dataTime}>
          <Icon className={'custom-tool-tip'} tokens={infoKnockoutTokens} />
        </Tooltip>
      </Heading>
      <Row width="100%" alignmentVertical="top">
        <Column spacing="50" alignmentVertical="center">
          <Text type="d50">{expectedData}</Text>
          <Text type="b100">Current Expected</Text>
        </Column>
        <Column spacing="50" alignmentVertical="center">
          <Text type="d50">{onsiteData}</Text>
          <Text type="b100">Current Onsite</Text>
        </Column>
        <Column spacing="50" alignmentVertical="center">
          <Text type="d50">{inductData}</Text>
          <Text type="b100">Active Inducting</Text>
        </Column>
        <Column spacing="50" alignmentVertical="center">
          <Text type="d50">{stowData}</Text>
          <Text type="b100">Active Stowing</Text>
        </Column>
        <Column spacing="50" alignmentVertical="center">
          <Text type="d50">{pickStageData}</Text>
          <Text type="b100">Active Picking</Text>
        </Column>
      </Row>
    </Box>
  );
};

export default HeadcountView;
